import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { VideoComponent } from '@content/ui/video';
import { TextField } from '@core/jss-proxy';
import { getField } from '@core/jss-utils';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-video-container',
  templateUrl: './video.container.component.html',
  standalone: true,
  imports: [VideoComponent, ContentSectionComponent],
})
export class VideoContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly fields = computed(() => this.rendering().fields);
  readonly headingField = computed(() =>
    getField<TextField>(this.fields(), 'heading')
  );
  readonly descriptionField = computed(() =>
    getField<TextField>(this.fields(), 'description')
  );
  readonly videoIdField = computed(() =>
    getField<TextField>(this.fields(), 'videoId')
  );
}
